import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { response } from 'express';
import { ConfirmationService } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { ContractAttachment } from 'src/app/intefaces/contract.interface';
import { AdminService } from 'src/app/services/admin.service';
import { ContractService } from 'src/app/services/contract.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-contract-attachments',
    templateUrl: './contract-attachments.component.html',
    styleUrls: ['./contract-attachments.component.scss'],
    providers: [ConfirmationService]
})
export class ContractAttachmentsComponent implements OnInit, OnDestroy {

    @Input() contractId: number;
    @Input() role: string;
    contractAttachments: ContractAttachment[] = [];
    showLoader: boolean = true;
    functionsMenu = [];
    showDialog: boolean = true;
    uploadInProgress: boolean = false;
    @ViewChild('menu') menu: Menu;

    constructor(private alertService: HttpAlertService, private translate: TranslateService, private contractService: ContractService, private confirmationService: ConfirmationService) { }

    ngOnInit(): void {
        this.getContractAttachmentData();
    }

    ngOnDestroy(): void { }

    @Output() closeModal: EventEmitter<any> = new EventEmitter();
    public onCloseModal(): void {
        this.closeModal.emit(this.contractId);
    }

    private getContractAttachmentData(): void {
        this.contractService.getContractAttachments(this.contractId).subscribe((response: any) => {
            this.contractAttachments = response.data.contrract_attachments;
            this.showLoader = false;
        });
    }

    public onDownloadAttachment(id: number): void {
        this.contractService.downloadContractAttachment(this.contractId, id).subscribe((response: any) => {
            if (response.size > 10) {
                for (let index = 0; index < this.contractAttachments.length; index++) {
                    if (this.contractAttachments[index].id == id) {
                        saveAs(response, this.contractAttachments[index].display_name);
                    }
                }
            } else {
                this.alertService.error('contract_error_general');
            }
        }, error => console.error(error));
    }

    public onAcceptAttatchment(id: number): void {
        this.getConfrimation('contract_attachemnts_confirmation_accept').then((confirmation: boolean) => {
            if (confirmation && 'admin' == this.role) {
                this.contractService.acceptContractAttachment(this.contractId, id).subscribe((response: any) => {
                    if ('ATTACHMENT_ACCEPTED' == response.data.status) {
                        this.alertService.success('contract_attachemnts_accept_confirm');
                        for (let i = 0; i < this.contractAttachments.length; i++) {
                            if (this.contractAttachments[i].id == id) {
                                this.contractAttachments[i].status = 'accepted';
                            }
                        }
                    } else if ('INCORRECT_CONTRACT_ATTACHMENT_ID' == response.data.status || 'INCORRECT_CONTRACT_ID' == response.data.status) {
                        this.alertService.error('contract_attachemnts_error_3');
                    } else {
                        this.alertService.error('contract_error_general');
                    }
                });
            }
        });
    }

    public onDeleteAttachment(id: number): void {
        this.getConfrimation('contract_attachemnts_confirmation_delete').then((confirmation: boolean) => {
            if (confirmation) {
                this.contractService.deleteContractAttachment(this.contractId, id).subscribe((response: any) => {
                    if ('ATTACHMENT_DELETED' == response.data.status) {
                        this.alertService.success('contract_attachemnts_deleted_confirm');
                        for (let i = 0; i < this.contractAttachments.length; i++) {
                            if (this.contractAttachments[i].id == id) {
                                this.contractAttachments.splice(i, 1);
                            }
                        }
                    } else if ('NOT_AUTHORIZED' == response.data.status) {
                        this.alertService.error('contract_attachemnts_error_2');
                    } else if ('INCORRECT_CONTRACT_ATTACHMENT_ID' == response.data.status || 'INCORRECT_CONTRACT_ID' == response.data.status) {
                        this.alertService.error('contract_attachemnts_error_3');
                    } else if ('CANNOT_DELETED_ACCEPTED_ATTACHMENT' == response.data.status) {
                        this.alertService.error('contract_attachments_error_4');
                    } else {
                        this.alertService.error('contract_error_general');
                    }
                });
            }
        });
    }

    public onRejectAttachment(id: number): void {
        this.getConfrimation('contract_attachemnts_confirmation_reject').then((confirmation: boolean) => {
            if (confirmation && 'admin' == this.role) {
                this.contractService.rejectContractAttachment(this.contractId, id).subscribe((response: any) => {
                    if ('ATTACHMENT_REJECTED' == response.data.status) {
                        this.alertService.success('contract_attachemnts_reject_confirm');
                        for (let i = 0; i < this.contractAttachments.length; i++) {
                            if (this.contractAttachments[i].id == id) {
                                this.contractAttachments[i].status = 'rejected';
                            }
                        }
                    } else if ('INCORRECT_CONTRACT_ATTACHMENT_ID' == response.data.status || 'INCORRECT_CONTRACT_ID' == response.data.status) {
                        this.alertService.error('contract_attachemnts_error_3');
                    } else {
                        this.alertService.error('contract_error_general');
                    }
                });
            }
        });
    }

    public onAttachmentChange($event: any): void {
        let files: File[] = $event.target.files;
        if (files.length) {
            this.uploadInProgress = true;
            const formData = new FormData();
            formData.append('attachment', files[0]);
            formData.append('file_name', files[0].name);
            formData.append('contract_id', String(this.contractId));
            this.contractService.saveContractAttachment(formData).subscribe((response: any) => {
                this.getContractAttachmentData();
                this.uploadInProgress = false;
            });
        }
    }

    public onPopulateFunctionsMenu(event: any, s: string, id: number): void {
        this.translate.get(['contract_attachemnts_accept', 'contract_attachemnts_reject', 'contract_attachemnts_download', 'contract_attachemnts_delete']).subscribe(t => {
            this.functionsMenu = [];
            this.functionsMenu.push({ label: t.contract_attachemnts_download, command: (click) => { this.onDownloadAttachment(id) } });
            if (('new' == s || 'rejected' == s) && 'admin' == this.role) {
                this.functionsMenu.push({ label: t.contract_attachemnts_accept, command: (click) => { this.onAcceptAttatchment(id) } });
            }
            if (('new' == s || 'accepted' == s) && 'admin' == this.role) {
                this.functionsMenu.push({ label: t.contract_attachemnts_reject, command: (click) => { this.onRejectAttachment(id) } });
            }
            this.functionsMenu.push({ label: t.contract_attachemnts_delete, command: (click) => { this.onDeleteAttachment(id) } });
            this.menu.toggle(event);
        });
    }

    public getConfrimation(title: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.confirmationService.confirm({
                message: this.translate.instant(title),
                accept: () => { resolve(true); },
                reject: () => { resolve(false); }
            });
        });
    }
}